import axios from 'axios'
import store from './store'
import {handleDates} from '@/utils/axios-utils'

const instance = axios.create({
    baseURL: String
});

instance.setBaseURL = (url) => {
    window.console.log('SPABoot API base URL: ' + url)
    instance.defaults.baseURL = url
}

instance.setAuthtoken = (authtoken) => {
    console.log('authentication token ' + authtoken)
    instance.defaults.headers.common['Authorization'] = 'Bearer ' + authtoken
};

instance.setBaseURL(process.env.VUE_APP_SPABOOT_API_URL)

instance.interceptors.response.use(originalResponse => {
    handleDates(originalResponse.data);
    return originalResponse;
});

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response && error.response.status === 401) {
            store.dispatch('logout')
            instance.setAuthtoken(null)
        }
        return Promise.reject(error)
    });


export default instance;


